const User = {
  state: {
    user: null,
  },
  mutations: {
    user: (state, playback) => {
      // eslint-disable-next-line
      state.user = playback;
    },
  },
  getters: {
    user: state => state.user,
  },
};

export default User;
